import { ViewController } from '@estee/elc-service';
import { computed, action, observable } from 'mobx';
import { FilterSet } from '../domain/entities/FilterSet';

export interface IOrderableFiltersData {
    isFiltersModalOpen?: boolean;
    isFilterInProgress?: boolean;
}

export class ProductFiltersViewController extends ViewController {
    @observable private isFiltersModalOpen: boolean = false;
    @observable private isFilterInProgress: boolean = false;

    @computed
    get data(): IOrderableFiltersData {
        return {
            isFiltersModalOpen: this.isFiltersModalOpen,
            isFilterInProgress: this.isFilterInProgress
        };
    }

    @action
    public onClearAllAppliedFilters(filtersSets: FilterSet[]) {
        filtersSets.forEach((filterSet) => filterSet.clearAllFilters());
    }

    @action
    public onOpenFiltersClick = () => {
        this.isFiltersModalOpen = true;
    };

    @action
    public onCloseFiltersClick = () => {
        this.isFiltersModalOpen = false;
    };
}
